import { alpha, darken, type Components, type Theme } from "@mui/material";

export const MuiBackdrop: Components<Theme>["MuiBackdrop"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      background: alpha(darken(theme.palette.common.black, 0.5), 0.2),
      "&.MuiBackdrop-invisible": {
        backgroundColor: "transparent",
      },
    }),
  },
};
